import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RESOURCES } from 'OpsCenter/app.constants';

@Injectable()
export class LoyaltyPointsService {
  PAGE_SIZE = 10;

  constructor(private http: HttpClient) {

  }

  uploadFile(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post(RESOURCES.LOYALTY_POINTS, formData);
  }

  getJobStatus(pageNumber: string) {
    return this.http.get(RESOURCES.LOYALTY_POINTS,
      {
        params: {
          page: pageNumber,
          pageSize: this.PAGE_SIZE.toString(),
        },
      })
      ;
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/loyalty-points/loyalty-points.service.ts